import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid, Paper, Snackbar, SnackbarContent, TextField, Typography} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Address from '../ui/Address'

import BusinessBeneficialOwnerCreateMutation from './BusinessBeneficialOwnerCreateMutation';
import PageTitle from '../ui/PageTitle';
import SavingSpinner from '../ui/SavingSpinner';
import CountrySelect from '../ui/CountrySelect'
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import classNames from 'classnames';
import AppBindStyles from '../../AppBindStyles';

import { green } from '@mui/material/colors';
import { differenceInYears, subYears } from 'date-fns';

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
    },
    flex: {
      flex: 1,
    },
    paper: {
      padding: theme.spacing(3),
      textAlign: 'left',
      color: theme.palette.text.secondary,
      maxWidth: 980,
      marginTop: 16
    },
    success: {
      backgroundColor: green[300],
    },
    error: {
      backgroundColor: theme.palette.error.light,
    },
    message: {
      display: 'flex',
      alignItems: 'center',
    },
    close: {
      padding: theme.spacing(0.5),
    },
    select: {
      marginLeft: -8,
      marginTop: -8,
    },
    dateField: {
      width: 160,
    },
    businessClassification: {
      margin: theme.spacing(1),
    }        
});
  
class BusinessBeneficialOwnerCreate extends Component {

    state = {
        showSpinner: false,
        saveStatus: null,
        saveMessage: null,
        snackbarOpen: false,

        ssn: '', 
        dateOfBirth: null,
        passportNumber: '',
        passportCountry: '',
        lastName: '', 
        firstName: '', 
        address1: '', 
        address2: '', 
        city: '', 
        state: '', 
        country: '', 
        postalCode: ''

    }
    
    goToAndReplaceURL(route) {
      this.props.history.replace(`/${route}`);
    }
  
    showSpinner() {
        return this.state.showSpinner;
    }

    enableSave() {
 
      if ((this.state.ssn == null || this.state.ssn.length === 0) && this.state.country === "US")
        return false;

      //validate ssn is 9 if US
      var re = /^\d{9}$/;
      if (this.state.country === "US" && !re.test(this.state.ssn)) {
        return false;
      }


      if (this.state.dateOfBirth == null || this.state.dateOfBirth.length === 0)
        return false;

      if (this.state.address1 == null || this.state.address1.length === 0)
        return false;


      if (this.state.city == null || this.state.city.length === 0)
        return false;

      if (this.state.state == null || this.state.state.length === 0)
        return false;

      if (this.state.country == null || this.state.country.length === 0)
        return false;

      if (this.state.postalCode == null || this.state.postalCode.length === 0)
        return false;

      if (this.state.country !== "US") {
        if (this.state.passportCountry == null || this.state.passportCountry.length === 0)
          return false;
        if (this.state.passportNumber == null || this.state.passportNumber.length === 0)
          return false;
      }

      const age = differenceInYears(new Date(), new Date(this.state.dateOfBirth));
      if (age < 18) {
        return false;
      }

 
      return true;
    }


    setCountry    = (country)    => { this.setState({country:    country}); }  
    setRegion     = (region)     => { this.setState({state:      region}); }  
    setCity       = (city)       => { this.setState({city:       city}); }  
    setPostalCode = (postalCode) => { this.setState({postalCode: postalCode}); }  
    setAddress1   = (address1)   => { this.setState({address1:   address1}); }  
    setAddress2   = (address2)   => { this.setState({address2:   address2}); }  
    setPassportCountry    = (country)    => { this.setState({passportCountry:    country}); }  

    handleSnackbarClose = (event, reason) => { 
      this.setState({ snackbarOpen: false, saveStatus: '', saveMessage: '' });
    };

    render() {
        const { isAuthenticated, isAuthenticatedReseller, needAssent } = this.props.auth;
        const classes = this.props.classes;

        if (!isAuthenticated() || needAssent()) {
          return (
            <Redirect to='/home' />
          );
        } else if (isAuthenticatedReseller()) {

          const params = new URLSearchParams(this.props.location.search);
          let biId = params.get('biId');
   
          let address = {
            country:    this.state.country,
            state:      this.state.state,
            city:       this.state.city,
            postalCode: this.state.postalCode,
            address1:   this.state.address1,
            address2:   this.state.address2
          };
          let regionLabel = "Region";

          // Determine the maximum date.  So 18 years ago
          let theMaxDate = subYears(new Date(), 18);

          let ssnErrorText = '';
          if (this.state.ssn && this.state.country === 'US' ) {
            //validate ein is 9
            var re = /^\d{9}$/;
            if (this.state.ssn && !re.test(this.state.ssn)) {
              ssnErrorText = 'SSN must be 9 numbers no dashes'
            }
          }

         
          return (
            <div id="beneficial-owner-create" className={classes.root}>
              <PageTitle title="Add a beneficial owner" subtitle="Person with more than 25% stake." showBackButton={true} name="Business Entity" history={this.props.history}/>

              <Paper className={classes.paper}>
                <Grid container spacing={2} direction="row" justifyContent="flex-start">
 
                    <Grid item xs={12} sm={6}>
                      <TextField  data-recording-ignore="mask"
                        id="first-name" label="First name *"
                        value={ this.state.firstName }
                        onChange={ (e) => this.setState({ firstName: e.target.value }) }
                        inputProps={{ maxLength: 32 }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField  data-recording-ignore="mask"
                        id="last-name" label="Last name *"
                        value={ this.state.lastName }
                        onChange={ (e) => this.setState({ lastName: e.target.value }) }
                        inputProps={{ maxLength: 32 }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <div style={AppBindStyles.datePickerField}>
                      <DatePicker data-recording-ignore="mask"
                        autoOk
                        label="Date of birth *"
                        value={ this.state.dateOfBirth } 
                        onChange={(date) => this.setState({ dateOfBirth: date }) }
                        className={classes.dateField}
                        format="YYYY-MM-DD"
                        maxDate={theMaxDate}
                        maxDateMessage="Business owner must be over 18"
                        renderInput={(params) => <TextField {...params} />}
                      />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField data-recording-ignore="mask"
                        id="ssn" label={"SSN (9 digits no dashes)" + ((this.state.country === "US") ? " *"  : "")}
                        value={ this.state.ssn }
                        onChange={ (e) => this.setState({ ssn: e.target.value }) }
                        inputProps={{ maxLength: 9 }}
                        error={ssnErrorText !== ''}
                        helperText={ssnErrorText}
                      />
                    </Grid>


                    <Grid item xs={12}>
                      <Address
                        showRequired={true}
                        address={address}
                        regionLabel={regionLabel}
                        setCountryCodeState={this.setCountry}
                        setRegionCodeState={this.setRegion}
                        setCityState={this.setCity}
                        setPostalCodeState={this.setPostalCode}
                        setAddress1State={this.setAddress1}
                        setAddress2State={this.setAddress2}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField data-recording-ignore="mask"
                        id="ppnumber" label={"Passport number" + ((this.state.country !== "US") ? " *"  : "")}
                        value={ this.state.passportNumber }
                        onChange={ (e) => this.setState({ passportNumber: e.target.value }) }
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                    <div className={classes.select}>
                      <CountrySelect data-recording-ignore="mask"
                        overrideLabel={'Passport country'}
                        showRequired={(this.state.country !== "US")}
                        countryCode={this.state.passportCountry}
                        setCountryCodeState={this.setPassportCountry}
                        
                      />
                    </div>
                    </Grid>


                  <Grid item xs={12}>
                  <div style={{display:'inline'}}>
                    { !this.showSpinner()  && this.enableSave() &&
                    <Button variant="contained" color="primary"  style={AppBindStyles.bottomButton}  onClick={() => {this._createBeneficialOwner(biId)}}>
                      Save
                    </Button>
                    }
                    { ((!this.showSpinner() && !this.enableSave())) &&
                    <Button variant="contained" color="primary"  disabled  style={AppBindStyles.bottomButton} >
                      Save
                    </Button>
                    }
                    { this.showSpinner() &&
                    <Button disabled={false} color="primary" variant="contained"  style={AppBindStyles.bottomButton} >
                      <SavingSpinner/></Button> }
                    
 
                      <Snackbar
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'center',
                        }}
                        open={this.state.snackbarOpen}
                        onClose={this.handleSnackbarClose}
                      >
                        <SnackbarContent
                          className={classNames(classes.message, classes[this.state.saveStatus])}
                          onClose={this.handleSnackbarClose}
                          message={
                            <Typography variant="body1">
                                {this.state.saveMessage}
                            </Typography>
                          }
                          action={[
                            <IconButton
                              key="close"
                              aria-label="Close"
                              color="inherit"
                              className={classes.close}
                              onClick={this.handleSnackbarClose}
                              size="large">
                            <CloseIcon />
                          </IconButton>
                        ]}
                      />
                    </Snackbar>

                  </div>

                  </Grid>
                </Grid>
              </Paper>

            </div>
          );
        } else {
          return (
            <Redirect to='/home' />
          );
        }
    }

    _createBeneficialOwner = (biId) => {

      let boId = null;

      this.setState({ showSpinner: true });
      const { ssn, dateOfBirth, passportNumber, passportCountry, lastName, firstName, 
        address1, address2, city, state, country, postalCode } = this.state;
      
      let newBirthDate = dateOfBirth;
      if (newBirthDate === '') {
        newBirthDate = null;
      }

      BusinessBeneficialOwnerCreateMutation.commit(biId, ssn, newBirthDate, passportNumber, passportCountry, lastName, firstName, 
        address1, address2, city, state, country, postalCode)
      .then(response => {
        boId = response.createBeneficialOwnerT.beneficialOwnerT.boId;

        
        return null;
      })
      .then(response => {
        localStorage.setItem('vsuccess', 'ss')
        this.setState({ showSpinner: false });
        let url = 'businessbeneficialowneredit?boId=' + boId;
        this.goToAndReplaceURL(url);
      })
      .catch(error => {
        this.setState({ showSpinner: false, snackbarOpen: true, saveStatus: 'error', saveMessage: 'Unable to save beneficial owner.' });
      });
    }


}

BusinessBeneficialOwnerCreate.propTypes = {
    classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(BusinessBeneficialOwnerCreate);